<template>
  <v-container class="max-w-full" fluid v-if="!$apollo.loading">
    <v-row>
      <v-col sm="12" lg="4"><InquiriesForm :inquiry="inquiry"/></v-col>
      <v-col sm="12" lg="8"><InquiriesTabs :inquiry="inquiry"/></v-col>
    </v-row>
  </v-container>
</template>

<script>
import InquiriesTabs from './InquiriesTabs'
import InquiriesForm from './InquiriesForm'
import GET_INQUIRY from '@/gql/inquiries/queries/GetInquiry.gql'

export default {
  name: 'InquiriesDetails',

  components: {
    InquiriesTabs,
    InquiriesForm,
  },

  apollo: {
    inquiry: {
      query: GET_INQUIRY,
      variables() {
        return {
          uuid: this.$route.params.uuid,
        }
      },
    },
  },
}
</script>
